import { render, staticRenderFns } from "./SlideshowBlock.vue?vue&type=template&id=063e6b88&"
import script from "./SlideshowBlock.vue?vue&type=script&lang=js&"
export * from "./SlideshowBlock.vue?vue&type=script&lang=js&"
import style0 from "./SlideshowBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports